import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import { auth } from '@internal/router/middleware/auth'
import middlewareGuard from '@shared/utils/middleware-guard'

import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import {
  temboUsers,
  dcm,
  settings,
  visits,
  organizations,
  notifications,
  anonymous,
  clinician,
  patients,
  notFound,
  authPage,
  analytics,
  alerts,
  tasks,
} from '@internal/router/route-list'

const routes: Array<RouteRecordRaw> = [
  ...authPage,
  {
    path: '/',
    name: ERouterList.HOME,
    component: () => import('@internal/pages/index.vue'),
    meta: {
      middleware: [auth],
    },
    children: [
      {
        path: '/',
        name: ERouterList.PLACEHOLDER,
        component: () => import('@internal/pages/placeholder.vue'),
        meta: {
          middleware: [auth],
          layout: InnerLayout,
        },
      },
      ...settings,
      {
        path: '/search',
        name: ERouterList.SEARCH,
        component: () => import('@internal/pages/search/index.vue'),
        meta: {
          middleware: [auth],
          layout: InnerLayout,
        },
      },
      ...alerts,
      ...visits,
      ...analytics,
      ...patients,
      ...organizations,
      ...temboUsers,
      ...clinician,
      ...notifications,
      ...anonymous,
      ...tasks,
      ...dcm,
    ],
  },
  ...notFound,
]

if (import.meta.env.TEMBO_ENABLE_MESSAGING === 'true') {
  routes.forEach(el => {
    if (el.name === ERouterList.HOME) {
      el.children?.push({
        path: '/messaging',
        name: ERouterList.MESSAGING,
        component: () => import('@internal/pages/messaging/index.vue'),
        meta: {
          middleware: [auth],
          layout: InnerLayout,
        },
      })
    }
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})
middlewareGuard(router)

router.onError(error => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload()
  }
})

export default router
